import {
  ButtonGroup,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  ButtonGroupProps,
} from '@chakra-ui/react';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import { SimpleDatePicker } from 'packages/common-frontend/components/SimpleDatePicker';

type MonitorModeControlsProps = ButtonGroupProps & {
  reportingDate: Util.FullDateStr;
  fileVersion: number;
  onMonitor: (reportingDate: Util.FullDateStr, fileVersion: number) => void;
};
export const MonitorModeControls = ({
  reportingDate,
  fileVersion,
  onMonitor,
  ...buttonGroupProps
}: MonitorModeControlsProps) => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <ButtonGroup id="monitor-mode-control-group" {...buttonGroupProps}>
      <SimpleDatePicker
        tz={clientTimeZone}
        dateFormat="MMM d, yyyy"
        selectedDate={commonDate.fullDateStrToDate(reportingDate)}
        showTimeSelect={false}
        setSelectedDate={(date: Date) => {
          const fullDateStr = commonDate.dateToFullDateString(
            date,
            clientTimeZone,
          );
          onMonitor(fullDateStr, fileVersion);
        }}
        width="140px"
      />
      <NumberInput
        size="md"
        maxW={24}
        defaultValue={1}
        min={0}
        max={2000}
        value={fileVersion}
        onChange={(value: string) => {
          onMonitor(reportingDate, Number(value));
        }}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
    </ButtonGroup>
  );
};
